/**
 * Brand-specific QueryBuilder configuration for CA
 * This configuration extends the core configuration with CA-specific rules
 */
import type {IQueryBuilderConfig} from 'coreClasses/content/providers/ContentHubV2Provider/QueryBuilder';

export const queryBuilderConfig: Partial<IQueryBuilderConfig> = {
	idMappings: {
		preorderMessage: {
			newId: 'text',
		},
		paginatedContentItems: {
			newId: 'paginatedContent',
			transformVariables: (variables) => {
				delete variables.contentSkip;
			},
		},
	},

	parseObjectRules: {
		directKeys: ['locale', 'select'],
	},
};

